import { Reducer } from 'redux';
import { OrdersState, OrdersTypes } from './types';

export const INITIAL_STATE: OrdersState = {
  ordersList: [],
  orderData: {
    payment: {
      type: '',
      data: {},
    },
    orders: [],
  },
  chargeRequestList: [],
  chargeRequestListFull: [],
  chargeRequestData: {
    id: '',
    userId: '',
    type: '',
    ChargeRequestOrders: [],
    status: 0,
    value: 0,
    nsu: null,
    PaymentRequest: {
      id: '',
      type: '',
      status: 0,
      value: 0,
      tax: 0,
      data: {},
      createdAt: '',
      updatedAt: '',
      chargeRequestId: '',
      PaymentRequestHistories: [],
    },
    createdAt: '',
    updatedAt: '',
    ChargeRequestHistories: [],
  },
  chargeRequestRepeatData: {
    id: '',
    userId: '',
    type: '',
    ChargeRequestOrders: [],
    status: 0,
    value: 0,
    nsu: null,
    PaymentRequest: {
      id: '',
      type: '',
      status: 0,
      value: 0,
      tax: 0,
      data: {},
      createdAt: '',
      updatedAt: '',
      chargeRequestId: '',
      PaymentRequestHistories: [],
    },
    createdAt: '',
    updatedAt: '',
    ChargeRequestHistories: [],
  },
  chargeBoleto: '',
  totalCount: 0,
  loading: false,
  error: false,
};

const reducer: Reducer<OrdersState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES GET ORDER
    case OrdersTypes.GET_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        chargeRequestData: INITIAL_STATE.chargeRequestData,
      };
    case OrdersTypes.GET_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        chargeRequestData: action.payload.chargeRequestData,
      };
    case OrdersTypes.GET_ORDER_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        chargeRequestData: INITIAL_STATE.chargeRequestData,
      };

    // LIST ORDERS
    case OrdersTypes.LIST_ORDERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        chargeRequestList: action.payload?.isCvFull
          ? state.chargeRequestList
          : INITIAL_STATE.chargeRequestList,
      };
    case OrdersTypes.LIST_ORDERS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        chargeRequestList: action.payload.chargeRequestList,
        totalCount: action.payload.totalCount,
      };
    case OrdersTypes.LIST_FULL_ORDERS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        chargeRequestListFull: action.payload.chargeRequestListFull,
        totalCount: action.payload.totalCount,
      };

    // LIST ORDERS
    case OrdersTypes.ASYNC_LIST_ORDERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        chargeRequestList: action.payload?.isCvFull
          ? state.chargeRequestList
          : INITIAL_STATE.chargeRequestList,
      };
    case OrdersTypes.ASYNC_LIST_ORDERS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        chargeRequestList: action.payload.chargeRequestList,
        totalCount: action.payload.totalCount,
      };
    case OrdersTypes.LIST_FULL_ORDERS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        chargeRequestListFull: action.payload.chargeRequestListFull,
        totalCount: action.payload.totalCount,
      };

    case OrdersTypes.ASYNC_LIST_ORDERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        chargeRequestList: INITIAL_STATE.chargeRequestList,
      };

    // CREATE ORDER
    case OrdersTypes.CREATE_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        chargeRequestData: INITIAL_STATE.chargeRequestData,
      };
    case OrdersTypes.CREATE_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        chargeRequestData: action.payload.chargeRequestData,
      };
    case OrdersTypes.CREATE_ORDER_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        chargeRequestData: INITIAL_STATE.chargeRequestData,
      };

    // REPEAT ORDER
    case OrdersTypes.CHARGE_REQUEST_REPEAT_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        chargeRequestRepeatData: INITIAL_STATE.chargeRequestRepeatData,
      };
    case OrdersTypes.CHARGE_REQUEST_REPEAT_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        chargeRequestRepeatData: action.payload.chargeRequestRepeatData,
      };
    case OrdersTypes.CHARGE_REQUEST_REPEAT_ORDER_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        chargeRequestRepeatData: INITIAL_STATE.chargeRequestRepeatData,
      };

    // DELETE ORDER
    case OrdersTypes.DELETE_ORDER_REQUEST:
      return { ...state, loading: true, error: false };
    case OrdersTypes.DELETE_ORDER_SUCCESS:
      return { ...state, loading: false, error: false };
    case OrdersTypes.DELETE_ORDER_FAILURE:
      return { ...state, loading: false, error: false };

    // GET ORDER PDF
    case OrdersTypes.GET_ORDER_PDF_REQUEST:
      return { ...state, loading: true, error: false };
    case OrdersTypes.GET_ORDER_PDF_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        chargeBoleto: action.payload.chargeBoleto,
      };
    case OrdersTypes.GET_ORDER_PDF_FAILURE:
      return { ...state, loading: false, error: false };

    // CHARGE REQUEST PAY BOLETO
    case OrdersTypes.CHARGE_REQUEST_PAY_BOLETO_ORDER_REQUEST:
      return { ...state, loading: true, error: false };
    case OrdersTypes.CHARGE_REQUEST_PAY_BOLETO_ORDER_SUCCESS:
      return { ...state, loading: false, error: false };
    case OrdersTypes.CHARGE_REQUEST_PAY_BOLETO_ORDER_FAILURE:
      return { ...state, loading: false, error: false };

    // CHARGE REQUEST PAY
    case OrdersTypes.CHARGE_REQUEST_PAY_ORDER_REQUEST:
      return { ...state, loading: true, error: false };
    case OrdersTypes.CHARGE_REQUEST_PAY_ORDER_SUCCESS:
      return { ...state, loading: false, error: false };
    case OrdersTypes.CHARGE_REQUEST_PAY_ORDER_FAILURE:
      return { ...state, loading: false, error: false };

    default:
      return { ...state };

    // FILTER ORDERS
    case OrdersTypes.FILTER_ORDER_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        chargeRequestList: INITIAL_STATE.chargeRequestList,
      };
    case OrdersTypes.FILTER_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        chargeRequestList: action.payload.chargeRequestList,
      };
    case OrdersTypes.FILTER_ORDER_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        chargeRequestList: INITIAL_STATE.chargeRequestList,
      };
  }
};

export default reducer;
